import React, { useState, useEffect } from "react";
import { Select, Space } from "antd";
import FormItem from "components/fields/FormItem";
import { MONTH_OPTIONS, MONTH_NAMES, getDayOptions } from "variables/constants";

const SelectDate = ({ 
    monthName = "", 
    dayName = "", 
    label = "",
    mode = "", 
    form, 
    recordData 
}) => {
  const [dayOptions, setDayOptions] = useState([]);

  useEffect(() => {
    if (recordData?.[monthName]) {
      setDayOptions(getDayOptions(recordData[monthName]));
    }
  }, [recordData, monthName]);

  const handleMonthChange = (month) => {
    if (!month) {
      setDayOptions([]);
      form.setFieldsValue({ [dayName]: null });
      return;
    }

    const options = getDayOptions(month);
    setDayOptions(options);

    const currentDay = form.getFieldValue(dayName);
    if (currentDay && currentDay > options.length) {
      form.setFieldsValue({ [dayName]: null });
    }
  };

  return (
    <div className="col-span-1 mb-2">
      <div className="pb-1 text-sm font-medium label-title">{label}</div>
      <Space.Compact className="gap-2 w-full">
        <FormItem name={monthName} noStyle>
          {mode !== "view" ? (
            <Select
              placeholder="MM"
              className="input-field"
              style={{ width: "65%" }}
              options={[{ value: null, label: "-" }, ...MONTH_OPTIONS]}
              onChange={handleMonthChange}
            />
          ) : (
            <span className="text-base label-value dark:text-white">
              {recordData?.[monthName] ? MONTH_NAMES[recordData[monthName] - 1] : "-"}
            </span>
          )}
        </FormItem>

        <FormItem name={dayName} noStyle>
          {mode !== "view" ? (
            <Select
              placeholder="DD"
              className="input-field"
              style={{ width: "35%" }}
              options={[{ value: null, label: "-" }, ...dayOptions]}
            />
          ) : (
            <span className="text-base label-value dark:text-white">
              {recordData?.[dayName] ?? "-"}
            </span>
          )}
        </FormItem>
      </Space.Compact>
    </div>
  );
};

export default SelectDate;
